import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useActions } from 'common/hooks';
import { instoreServiceActions, instoreServiceName, instoreServiceReducer } from '../slice';
import { instoreServiceRootSaga } from '../saga';

export const useInstoreServiceSlice = () => {
	useInjectReducer({ key: instoreServiceName, reducer: instoreServiceReducer });
	useInjectSaga({ key: instoreServiceName, saga: instoreServiceRootSaga });
	return useActions(instoreServiceActions);
};
